import { lazy } from "react";

import MainLayout from "layout/MainLayout";
import Loadable from "components/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import ListPage from "pages/lists/ListPage";

const Dashboard = Loadable(lazy(() => import("pages/dashboard")));
const Orders = Loadable(lazy(() => import("pages/orders")));
const Sales = Loadable(lazy(() => import("pages/sales")));
const Lists = Loadable(lazy(() => import("pages/lists")));
const Profile = Loadable(lazy(() => import("pages/profile")));

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "",
      element: <Dashboard />,
    },
    {
      path: "orders",
      element: <Orders />,
    },
    {
      path: "sales",
      element: <Sales />,
    },
    {
      path: "lists",
      element: <Lists />,
    },
    {
      path: "lists/:listId",
      element: <ListPage />,
    },
    {
      path: "profile",
      element: <Profile />,
    },
  ],
};

export default MainRoutes;
